// @ts-nocheck
import { useState, useEffect } from 'react'
import {
    useParams,
    useHistory
  } from "react-router-dom";
import { toast } from 'react-toastify';

import { getRequest } from "clients/ApiClient"
import { useAuth } from "contexts/AuthContext"
import { useAppSettings } from "contexts/AppSettingsContext"
import { processAppSettingsLanguages } from 'utils/settings'

import { formatDateForApi } from 'utils/datetime'

const getNewProfile = () => {
    return { 
        description: "",
        is_translator: false,
        is_interpreter: false,
        keywords: [],
        languages: [],
        education: [],
        experience: []
    }
}

const getNewLanguage = () => {
    return {
        language: "",
        is_native: false,
    }
}

const getNewEducation = () => {
    return {
        title: "",
        description: ""
    }
}

const getNewExperience = () => {
    return {
        title: "",
        description: ""
    }
}

const fetchTranslatorProfile = async (translatorProfileId, setTranslatorProfile, authContext, setIsLoading, setError) => {
    const { authGetRequest } = authContext
    setIsLoading(true)
    try {
        const userTranslatorProfile = await authGetRequest(`/translators/${translatorProfileId}`)

        if(!userTranslatorProfile.data.code) {
            const translatorProfile = {
                user: {...userTranslatorProfile.data},
                profile: {...userTranslatorProfile.data.profiles.find(p => p.role === 'translator')}
            }
        
            if(translatorProfile.profile.company) {
                setIsLoading(true)
        
                const [company, error] = await fetchCompanyProfile(translatorProfile.profile.company.id, authContext)
                setIsLoading(false)
        
                if(error) {
                    setError(error)
                    return
                }
        
                translatorProfile.companyUser = company.user
                translatorProfile.companyProfile = company.profile
            }
        
            setTranslatorProfile(translatorProfile)
        }
        else {
            switch(userTranslatorProfile.data.code) {
                case 404:
                case 400:
                    console.log(userTranslatorProfile)
                    throw new Error('Der Profil wurde entweder gelöscht oder konnte nicht gefunden werden.')
                default:
                case 500:
                    throw new Error('Beim Laden des Profils ist ein Fehler aufgetreten')
            }
        }
    }
    catch(e) {
        setTranslatorProfile(undefined)
        setError(e.message)
    }
    setIsLoading(false)
}

const fetchCompanyProfile = async (companyProfileId, authContext) => {
    const { authGetRequest } = authContext
    let company
    let error
    try {
        const companyProfile = await authGetRequest(`/translators/${companyProfileId}`)

        if(!companyProfile.data.code) {
            company = {
                user: {...companyProfile.data},
                profile: {...companyProfile.data.profiles.find(p => p.role === 'translator')}
            }
        }
        else {
            switch(companyProfile.data.code) {
                case 404:
                case 400:
                    console.log(companyProfile)
                    throw new Error('Der Profil wurde entweder gelöscht oder konnte nicht gefunden werden.')
                default:
                case 500:
                    throw new Error('Beim Laden des Profils ist ein Fehler aufgetreten')
            }
        }
    }
    catch(e) {
        error = e.message
    }
    
    return [company, error]
}

const setTranslatorProfileFromAuthContext = async (
    setTranslatorProfile, 
    authContext, 
    setIsLoading, 
    setError, 
    setOriginalTranslatorProfile,
    setIsFirstTimeProfile,
    setShowTab,
    updateProfile,
    updateCompanyProfile
) => {
    const translatorProfile = {
        user: {...authContext.currentUser},
        profile: {...authContext.currentUser.activeProfile}
    }

    if(translatorProfile.profile.company) {
        setIsLoading(true)

        const [company, error] = await fetchCompanyProfile(translatorProfile.profile.company.id, authContext)
        setIsLoading(false)

        if(error) {
            setError(error)
            return
        }

        translatorProfile.companyUser = company.user
        translatorProfile.companyProfile = company.profile
    }

    setTranslatorProfile(translatorProfile)
    setOriginalTranslatorProfile({
        ...translatorProfile
    })

    if(!authContext.currentUser.activeProfile?.is_completed) {
        setIsFirstTimeProfile(true)
        setShowTab('update')
        updateProfile({
            translator_profile: getNewProfile()
        })
        if(translatorProfile.companyUser) {
            updateCompanyProfile({
                translator_profile: getNewProfile()
            })
        }
    }
}

const TranslatorProfileController = ({
    isMyProfile,
    id
}) => {
    const authContext = useAuth()
    const appSettings = useAppSettings()

    const [translatorProfile, setTranslatorProfile] = useState()
    const [originalTranslatorProfile, setOriginalTranslatorProfile] = useState()
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState()
    const [validationErrors, setValidationErrors] = useState({})
    const history = useHistory()
    const [isFirstTimeProfile, setIsFirstTimeProfile] = useState(false)
    const [showTab, setShowTab] = useState('info')
    const [showProfile, setShowProfile] = useState(0)

    const languages = processAppSettingsLanguages(appSettings.appSettings.languages)

    useEffect(() => {
        if(isMyProfile) {
            setTranslatorProfileFromAuthContext(
                setTranslatorProfile, 
                authContext, 
                setIsLoading, 
                setError, 
                setOriginalTranslatorProfile,
                setIsFirstTimeProfile,
                setShowTab,
                updateProfile,
                updateCompanyProfile
            )
        }
        else if(id) {
            fetchTranslatorProfile(id, setTranslatorProfile, authContext, setIsLoading, setError)
        }
        else {
            setTranslatorProfile(undefined)
            setError('Der Kontakt wurde entweder gelöscht oder konnte nicht gefunden werden.')
        }
    }, [isMyProfile, id, authContext])

    const handleSubmitForm = async (e) => {
        e.preventDefault()
        try {
            const res = await authContext.authPatchRequest(`/my/translator-profile`, {
                ...translatorProfile.profile,
                is_completed: true
            })
            
            if(!res.data.code) {
                if(translatorProfile?.companyProfile) {
                    const res2 = await authContext.authPatchRequest(`/my/translator-profile-company`, {
                        ...translatorProfile.companyProfile,
                        is_completed: true
                    })

                    if(res2.data.code) {
                        switch(res.data.code) {
                            case 400:
                                throw new Error(res.data.message)
                            default:
                            case 500:
                                throw new Error('Beim Aktualisieren Ihres Profils ist ein Fehler aufgetreten')
                        }
                    }
                }

                toast.success('Ihr Profil wurde erfolgreich aktualisiert')
                setShowTab('info')
                setIsFirstTimeProfile(false)
                authContext.setCurrentUser({
                    ...res.data,
                    activeProfile: res.data.profiles.find(p => p.is_active_profile)
                })
            }
            else {
                switch(res.data.code) {
                    case 400:
                        throw new Error(res.data.message)
                    default:
                    case 500:
                        throw new Error('Beim Aktualisieren Ihres Profils ist ein Fehler aufgetreten')
                }
            }
        }
        catch(e) {
            toast.error(e.message)
        }
    }

    const updateProfile = (updates) => {
        setTranslatorProfile((prevProfile) => ({
            ...prevProfile,
            profile: {
                ...prevProfile.profile,
                ...updates
            }
        }))
    }

    const updateProfileTranslatorProfile = (updates) => {
        setTranslatorProfile((prevProfile) => ({
            ...prevProfile,
            profile: {
                ...prevProfile.profile,
                translator_profile: {
                    ...prevProfile.profile.translator_profile,
                    ...updates
                }
            }
        }))
    }

    const updateCompanyProfile = (updates) => {
        setTranslatorProfile((prevProfile) => ({
            ...prevProfile,
            companyProfile: {
                ...prevProfile.companyProfile,
                ...updates
            }
        }))
    }

    const updateCompanyProfileTranslatorProfile = (updates) => {
        setTranslatorProfile((prevProfile) => ({
            ...prevProfile,
            companyProfile: {
                ...prevProfile.companyProfile,
                translator_profile: {
                    ...prevProfile.companyProfile.translator_profile,
                    ...updates
                }
            }
        }))
    }

    const setKeywords = (keywords) => {
        setTranslatorProfile((prevProfile) => ({
            ...prevProfile,
            profile: {
                ...prevProfile.profile,
                translator_profile: {
                    ...prevProfile.profile.translator_profile,
                    keywords
                }
            }
        }))
    }

    const addLanguage = () => {
        setTranslatorProfile((prevProfile) => ({
            ...prevProfile,
            profile: {
                ...prevProfile.profile,
                translator_profile: {
                    ...prevProfile.profile.translator_profile,
                    languages: [
                        ...prevProfile.profile.translator_profile.languages,
                        getNewLanguage()
                    ]
                }
            }
        }))
    }

    const updateLanguage = (i, updates) => {
        setTranslatorProfile((prevProfile) => ({
            ...prevProfile,
            profile: {
                ...prevProfile.profile,
                translator_profile: {
                    ...prevProfile.profile.translator_profile,
                    languages: prevProfile.profile.translator_profile.languages.map((language, u) => {
                        if(u === i) { 
                            return {
                                ...language,
                                ...updates
                            }
                        }
                        else {
                            return language
                        }
                    })
                }
            }
        }))
    }

    const removeLanguage = (i) => {
        setTranslatorProfile((prevProfile) => ({
            ...prevProfile,
            profile: {
                ...prevProfile.profile,
                translator_profile: {
                    ...prevProfile.profile.translator_profile,
                    languages: prevProfile.profile.translator_profile.languages.filter((l, u) => u !== i)
                }
            }
        }))
    }

    const addLanguageToCompany = () => {
        setTranslatorProfile((prevProfile) => ({
            ...prevProfile,
            companyProfile: {
                ...prevProfile.companyProfile,
                translator_profile: {
                    ...prevProfile.companyProfile.translator_profile,
                    languages: [
                        ...prevProfile.companyProfile.translator_profile.languages,
                        getNewLanguage()
                    ]
                }
            }
        }))

        console.log("ADD LANG")
    }

    const updateLanguageToCompany = (i, updates) => {
        setTranslatorProfile((prevProfile) => ({
            ...prevProfile,
            companyProfile: {
                ...prevProfile.companyProfile,
                translator_profile: {
                    ...prevProfile.companyProfile.translator_profile,
                    languages: prevProfile.companyProfile.translator_profile.languages.map((language, u) => {
                        if(u === i) { 
                            return {
                                ...language,
                                ...updates
                            }
                        }
                        else {
                            return language
                        }
                    })
                }
            }
        }))
    }
    
    const removeLanguageFromCompany = (i) => {
        setTranslatorProfile((prevProfile) => ({
            ...prevProfile,
            companyProfile: {
                ...prevProfile.companyProfile,
                translator_profile: {
                    ...prevProfile.companyProfile.translator_profile,
                    languages: prevProfile.companyProfile.translator_profile.languages.filter((l, u) => u !== i)
                }
            }
        }))
    }


    const addEducation = () => {
        setTranslatorProfile((prevProfile) => ({
            ...prevProfile,
            profile: {
                ...prevProfile.profile,
                translator_profile: {
                    ...prevProfile.profile.translator_profile,
                    education: [
                        ...prevProfile.profile.translator_profile.education,
                        getNewEducation()
                    ]
                }
            }
        }))
    }

    const updateEducation = (i, updates) => {
        setTranslatorProfile((prevProfile) => ({
            ...prevProfile,
            profile: {
                ...prevProfile.profile,
                translator_profile: {
                    ...prevProfile.profile.translator_profile,
                    education: prevProfile.profile.translator_profile.education.map((education, u) => {
                        if(u === i) {
                            return {
                                ...education,
                                ...updates
                            }
                        }
                        else {
                            return education
                        }
                    })
                }
            }
        }))
    }

    const removeEducation = (i) => {
        setTranslatorProfile((prevProfile) => ({
            ...prevProfile,
            profile: {
                ...prevProfile.profile,
                translator_profile: {
                    ...prevProfile.profile.translator_profile,
                    education: prevProfile.profile.translator_profile.education.filter((e, u) => i !== u)
                }
            }
        }))
    }

    const addExperience = () => {
        setTranslatorProfile((prevProfile) => ({
            ...prevProfile,
            profile: {
                ...prevProfile.profile,
                translator_profile: {
                    ...prevProfile.profile.translator_profile,
                    experience: [
                        ...prevProfile.profile.translator_profile.experience,
                        getNewExperience()
                    ]
                }
            }
        }))
    }

    const updateExperience = (i, updates) => {
        setTranslatorProfile((prevProfile) => ({
            ...prevProfile,
            profile: {
                ...prevProfile.profile,
                translator_profile: {
                    ...prevProfile.profile.translator_profile,
                    experience: prevProfile.profile.translator_profile.experience.map((experience, u) => {
                        if(u === i) {
                            return {
                                ...experience,
                                ...updates
                            }
                        }
                        else {
                            return experience
                        }
                    })
                }
            }
        }))
    }

    const removeExperience = (i) => {
        setTranslatorProfile((prevProfile) => ({
            ...prevProfile,
            profile: {
                ...prevProfile.profile,
                translator_profile: {
                    ...prevProfile.profile.translator_profile,
                    experience: prevProfile.profile.translator_profile.experience.filter((e, u) => i !== u)
                }
            }
        }))
    }

    const handleCancelForm = () => {
        setTranslatorProfile({
            ...originalTranslatorProfile
        })
        setShowTab('info')
    }

    return {
        user: translatorProfile?.user,
        profile: translatorProfile?.profile,
        companyUser: translatorProfile?.companyUser,
        companyProfile: translatorProfile?.companyProfile,
        showProfile, 
        setShowProfile,
        isLoading,
        error,
        showTab,
        setShowTab,
        handleSubmitForm,
        handleCancelForm,
        validationErrors,
        languages,
        isFirstTimeProfile,
        updateProfile,
        updateProfileTranslatorProfile,
        updateCompanyProfile,
        updateCompanyProfileTranslatorProfile,
        setKeywords,
        addLanguage,
        updateLanguage,
        removeLanguage,
        addLanguageToCompany,
        updateLanguageToCompany,
        removeLanguageFromCompany,
        addEducation,
        updateEducation,
        removeEducation,
        addExperience,
        updateExperience,
        removeExperience,
    }
}

export default TranslatorProfileController
